import * as Sentry from "@sentry/react";
import { ENVIRONMENT } from "./env";
import { beforeSend } from "./util/sentry";

export default (() => {
    // An IIFE that is exported and then imported at the root of App.tsx
    if (
        import.meta.env.REACT_APP_GITHUB_BRANCH &&
        import.meta.env.REACT_APP_SOURCE_VERSION
    ) {
        // Enables sentry error tracking for `master` and `production` branches.
        Sentry.init({
            dsn: "https://d06a82439e314d08a7a9cd501b01740e@sentry.io/1726231",
            integrations:
                ENVIRONMENT === "prod"
                    ? []
                    : [Sentry.browserTracingIntegration()],
            release: import.meta.env.REACT_APP_SOURCE_VERSION,
            environment: import.meta.env.REACT_APP_GITHUB_BRANCH,

            // We recommend adjusting this value in production, or using tracesSampler
            // for finer control
            tracesSampleRate: 1.0,

            beforeSend,
        });
    }
})();
